<!--
  @component
  Generates an HTML x-axis, useful for server-side rendered charts.  This component is also configured to detect if your x-scale is an ordinal scale. If so, it will place the markers in the middle of the bandwidth.
 -->
<script>
  import { getContext } from 'svelte';

  export let bottom = false;

  const { xScale } = getContext('LayerCake');

  const ms = [
    'Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez',
  ];

</script>

<div class="months">
  {#each ms as m, i}
    <div class="month" class:hide1={i%2 !== 0} class:hide2={i%3 !== 0} class:bottom={bottom} style='left:{$xScale(i+0.5)}%;'>{m}</div>
  {/each}
</div>

<style>
  .month {
    top: -15px;
    font-size: 10px;
    line-height: 10px;
    position: absolute;
    font-family: "Franklin Gothic FS", Helvetica, Arial, sans-serif;
    transform: translateX(-50%);
    color: #666;
  }

  .month.bottom {
    top: auto;
    bottom: -15px;
  }

  @media (max-width: 480px) {
    .hide1 { display: none; }
  }

</style>
